var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var AutoSubmitTextArea = require("components/utility/AutoSubmitTextArea");
var Glyphicon = require("components/utility/icons/Glyphicon");
var CurrentUser = require("lib/account/CurrentUser");
var StandardComments = require("lib/academic/StandardComments");

class CommentForm extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var isSecret = true;

		this.state = {
			secret: isSecret, inFocus: false
		};
	}

	submitComment(isSecret) {
		var text = this.refs.commentTextArea.text();
		if (text.length > 0) {
			var commentData = { body: text, secretive: isSecret, 
				news_feed_item_id: this.props.itemID };

			if (this.props.comment) {
				commentData.id = this.props.comment.id;
			}

			this.props.onSubmit(commentData);
		}
	}

	focusChange(inFocus) {
		this.setState({ inFocus: inFocus });
	}

	reset() {
		this.refs.commentTextArea.reset();
		this.refs.errors.reset();
	}

	buildSubmitF(isSecret) {
		return function(e) {
			$wr.nope(e)
			this.setState({ secret: isSecret });
			this.submitComment(isSecret)
		}.bind(this);
	}

	getExtraButtons() {
		if (CurrentUser.isAdmin()) {
			var publicOp = (
				<span>
					<Glyphicon icon="eye-open" />{" "}
					Public <span className="details">(to class)</span>
				</span>
			);
			var privateOp = (
				<span>
					<Glyphicon icon="eye-close" />{" "}
					Private <span className="details">(student only)</span>
				</span>
			);

			if (this.state.secret) {
				var selText = "Private";
				var selIcon = "eye-close";
			} else {
				var selText = "Public";
				var selIcon = "eye-open";
			}

			var selOp = this.state.secret ? privateOp : publicOp;

			return (
				<ButtonDropdown text={ selText } icon={ selIcon } className="commentSubmitButtons">
					<ButtonDropdownOption text="Public (to class)" icon="eye-open"
						onClick={ this.buildSubmitF(false) } />
					<ButtonDropdownOption text="Private (student only)" icon="eye-close"
						onClick={ this.buildSubmitF(true) } />
				</ButtonDropdown>
			);

		}
	}

	render() {
		var currentUser = CurrentUser.get();
		if (currentUser && currentUser.settings && currentUser.settings.block_comments) {
			return (
				<p><em>Your teacher has blocked you from making comments....</em></p>
			)

		} else {
			var className = "commentTextArea";
			if (CurrentUser.isAdmin()) {
				className += " commentTextAreaAdmin";
				var placeholderText = "Give feedback on this answer"
			} else if (CurrentUser.isStudent()) {
				className += " commentTextAreaStudent";
				var placeholderText = "Respond to your teacher here"
			}
			if (this.props.comment) {
				var text = this.props.comment.body;
			} else if (this.state.inFocus && CurrentUser.isAdmin() && !this.props.noSuggestedComments) {
				var defaultCommentOptions = _.map(StandardComments.ALL, function(item) {
					var color = item.type == "positive" ? "#70d544" : "#da3956";
					return _.extend({}, item, { label: item.body, value: item.body, color: color });
				});

				className += " withSuggestions";
			}

			return (
				<div className="clearfix commentForm">
					<div className={ className }>
						<ErrorDisplay ref="errors" />
						<AutoSubmitTextArea ref="commentTextArea" onSubmit={ this.buildSubmitF(this.state.secret) }
							className="form-control makeComment expandOnFocus" submitLink={ true }
							prefillOptions={ defaultCommentOptions }
							onFocus={ this.focusChange.bind(this, true) } onBlur={ this.focusChange.bind(this, false) }
							defaultValue={ text } placeholder={ placeholderText } />
					</div>
				</div>
			);
		}
	}
};

CommentForm.propTypes = StrictPropTypes({
	// Function to pass submitted data to
	onSubmit: PropTypes.func.isRequired,

	// Exisiting comment we're editing. If undefined, it's a new comment
	comment: PropTypes.object,

	noSuggestedComments: PropTypes.bool
});

module.exports = CommentForm;



// WEBPACK FOOTER //
// ./modules/components/social/comments/CommentForm.js